export enum ActionProductSequencing {
    View_Assigned_Loads = 1,
    According = 2,
    Trigger_vehicle_for_weighing = 3,
    Suggest_Change = 4,
    load_Suggestion_Agreement_Histories = 5,
}
